import { Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {isPlatformServer} from "@angular/common";
 import {environment} from "../environments/environment";



@Injectable({providedIn:'root'})
export class AppService{

  site!:any
  host!:any
  urlBackend!:string

  constructor(private http: HttpClient,
             ) {


  }

  getApiUrl(): string {
    //return `http://localhost:3010/api`
    return `${environment.production ? 'https://'+this.host : environment.apiUrl}/api`
  }

  async getSite(){
    const url = `${this.getApiUrl()}/site/${this.host}`
    return lastValueFrom(this.http.get<any>(url))
  }

  async getArticle(slugTheme:string ,slugArticle:string){
    return lastValueFrom(this.http.get<any>(`${this.getApiUrl()}/articleBySlug/${slugTheme}/${slugArticle}`))
  }

  async getArticleByTheme(slugTheme:string ){
    return lastValueFrom(this.http.get<any>(`${this.getApiUrl()}/theme/${slugTheme}`))
  }

  async getArticleByTag(tag:string){
    return lastValueFrom(this.http.get<any[]>(`${this.getApiUrl()}/articleByTag/${tag}`))
  }

  getArticles(limit = 17, page = 1) {
    return lastValueFrom(this.http.get<any>(`${this.getApiUrl()}/article?limit=${limit}&page=${page}`))
  }

  async getArticlesByProductId(productId:number) {
    return lastValueFrom(this.http.get<any>(`${this.getApiUrl()}/articlesByProductId/${productId}`))
  }

}
